// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
// import "normalize.css"
// import './utils/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import store from './store/index'
import VueClipboard from 'vue-clipboard2'
import echarts from 'echarts'

import '@/common/css/index.scss'

Vue.prototype.$echarts = echarts
Vue.use(VueClipboard)
// import VueDragResize from 'vue-drag-resize'

Vue.use(ElementUI)

// Vue.component('vue-drag-resize', VueDragResize)

Vue.config.productionTip = false

router.beforeEach((to,form,next)=>{
  window.document.title = to.meta.title == undefined?'默认标题':'星火科技流量合作平台-'+to.meta.title
  let item=localStorage.getItem('userInfo')
  if(item || to.path==='/login'||to.path==='/agreement'){
    next()
  }else{
    next({
      path:'/login'
    })
  }
})


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js